import React, { Component } from "react";
import styles from './styles.css'

class FeatureProject extends Component {
  render() {
    return (
      <div className='feature-project'>
        <div className="feature-project__row">
          <div className="feature-project__feature--mobile">
            <img src={this.props.feature}></img>
          </div>
          <div className="feature-project__details">
            <div><img src={this.props.logo}></img></div>
            <p><a target="_blank" href={this.props.link}>Visit Website</a></p>
            <p>{this.props.blurb} - {this.props.tags}</p>
            <p>{this.props.description}</p>
          </div>
          <div className="feature-project__feature">
            <img src={this.props.feature}></img>
          </div>
        </div>
      </div>
    );
  }
}

export default FeatureProject;



// WEBPACK FOOTER //
// ./src/components/FeatureProject/index.js